"use client";

import { QueryResponseInitial, useQuery } from "@sanity/react-loader";
import { SanityDocument } from "next-sanity";

import { technologyPageQuery } from "@otomoro/sanity/lib/queries/pages/technologyPage.groq";
import TechnologyPage from "./TechnologyPage";

export default function TechnologyPagePreview({
  initial,
}: {
  initial: QueryResponseInitial<SanityDocument[]>;
}) {
	const { data } = useQuery<SanityDocument[] | null>(
    technologyPageQuery,
    {},
    { initial }
  );

	return data ? (
    <TechnologyPage data={data as any} />
  ) : (
    <div className="bg-red-100">No posts found</div>
  );
}